<template>
  <div class="container-fluid">
    <!-- <div class="row">
      <div class="col-12 mx-auto red-line py-2 px-0"></div>
    </div>-->

    <div
      class="col-12 col-md-8 col-lg-6 my-4 col-xl-4 px-0 px-md-3 mx-auto confirmScreenT"
    >
      <div class="text-center">
        <img
          src="@/assets/img/svg/ticket-checked.svg"
          width="120px"
          class="img-fluid"
        />
        <p data-v-23f776d6="" class="tTitle mt-3">
          Good News! <br />Ticket(s) Booked
        </p>
        <p data-v-23f776d6="" class="ntext my-3">
          You will soon receive an email / SMS from us with details
        </p>
        <p data-v-23f776d6="" class="eTitle">
          <!-- <p class="tTitle mt-3" v-html="bookingDetails.MsgTitle"></p>
        <p v-html="bookingDetails.Message" class="ntext my-3">
          {{ bookingDetails.MsgTitle }} {{ bookingDetails.Message }}.
        </p> -->
        </p>

        <p class="eTitle">
          Booking ID :
          <span>{{ bookingDetails.sb_booking_code }}</span>
        </p>
        <!-- <div class="cus-spaceDiv">
          <button class="btn btn-danger w-100 gogo-cus-btn">Download M-Ticket</button>
          <div class="px-2">&nbsp;</div>
          <button class="btn btn-danger w-100 gogo-cus-btn">Print M-Ticket</button>
        </div>-->
      </div>
    </div>

    <!-- Print this part -->
    <div v-html="legacySystemHTML"></div>

    <div
      v-if="Object.keys(bookingDetails).length > 0"
      id="printMe2"
      class="col-12 col-md-12 col-lg-11 col-xl-9 px-0 px-md-3 mx-auto"
    >
      <div class="d-none d-lg-block">
        <div class="corner-circle-top mt-5 mx-2 ticket-shadow">
          <div class="corner-circle-bottom bg-light m-ticket-web">
            <!--  -->
            <div class="col-12">
              <div class="row">
                <div class="col-8 p-4 p-xl-5">
                  <div class="h-100">
                    <div class="row">
                      <div class="col-3 pr-0 pr-xl-3">
                        <img
                          v-lazy="bookingDetails.md_thumbnail_url"
                          class="img-fluid rounded"
                        />
                      </div>

                      <div class="col-9">
                        <div class="px-3">
                          <!-- FIRST ROW -->
                          <div class>
                            <p
                              class="text-capitalize font-weight-bold mb-0 ticket-mtitle"
                            >
                              {{ bookingDetails.movie_title }}
                            </p>
                            <ul class="list-inline m-tick-mInfo">
                              <li class="list-inline-item">
                                {{ bookingDetails.lang_name }} ({{
                                  bookingDetails.mf_name
                                }})
                              </li>
                              <li class="list-inline-item">
                                {{ bookingDetails.show_date | moment }}
                              </li>
                              <li class="list-inline-item">
                                {{ bookingDetails.rating }}
                              </li>
                            </ul>
                          </div>

                          <!-- SECOND ROW -->
                          <div
                            class="d-flex justify-content-between align-items-end my-3"
                          >
                            <div>
                              <p class="mb-0 txt14-light-blue">
                                {{ bookingDetails.cine_name }} -
                                {{ bookingDetails.screen_name }}
                              </p>
                              <!-- <p class="mb-0">{{bookingDetails.Address}}</p> -->
                              <div class="d-flex align-items-center text-dark">
                                <div class="mr-1">
                                  <span>{{
                                    timeFormat(bookingDetails.show_time)
                                  }}</span>
                                  |
                                  <!-- <span class="tfText">
                                    {{ bookingDetails.timing[1] }}
                                    <span class="mx-1">|</span>
                                  </span>-->
                                </div>
                                <div class="mr-1">
                                  <span class>{{
                                    (" " + bookingDetails.show_date) | moment
                                  }}</span>
                                  <!-- <span>{{bookingDetails.month}}, {{bookingDetails.year}}</span> -->
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- THIRD ROW -->
                          <div
                            class="d-flex justify-content-between align-items-center my-3"
                          >
                            <div v-if="bookingDetails.seats">
                              <p class="text-muted mb-0 tiny">
                                Seats:
                                {{
                                  bookingDetails.booking_type_id != 3
                                    ? bookingDetails.seats.length
                                    : bookingDetails.screen_total_seats
                                }}
                              </p>
                              <ul class="list-inline mt-seat-list mb-0">
                                <li class="list-inline-item mx-0">
                                  {{
                                    bookingDetails.seats
                                      .join(", ")
                                      .replace("Hall", "Auditorium")
                                  }}
                                </li>
                              </ul>
                            </div>
                          </div>
                          <!-- FOURTH ROW -->
                          <div class="m-ticket-details">
                            <div class="row mb-2">
                              <div class="col-xl-7 text-muted tiny col-md-6">
                                Ticket Price
                              </div>
                              <div
                                class="col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"
                              >
                                {{ curr_code }}
                                {{
                                  currFormat(bookingDetails.sb_total_net_amount)
                                }}
                              </div>
                            </div>

                            <div
                              class=""
                              v-if="
                                bookingDetails.chargeTypeArray &&
                                  bookingDetails.chargeTypeArray.length > 0
                              "
                            >
                              <div
                                class="row mb-2"
                                v-for="(charge,
                                chargeIndex) in bookingDetails.chargeTypeArray"
                                :key="chargeIndex"
                              >
                                <div class="col-xl-7 text-muted tiny col-md-6">
                                  {{ charge.ct_name }}
                                </div>
                                <div
                                  class="col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"
                                >
                                  {{ curr_code }}
                                  {{ currFormat(charge.tax_amount) }}
                                </div>
                              </div>
                            </div>

                            <div class="row mb-2">
                              <div class="col-xl-7 text-muted tiny col-md-6">
                                Discount
                              </div>
                              <div
                                class="col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"
                              >
                                {{ curr_code }}
                                {{ currFormat(bookingDetails.offer_price) }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- LAST ROW -->
                        <div
                          class="px-3 mt-2 pt-2 d-md-none d-lg-block mt-border-top"
                        >
                          <div class="m-ticket-details">
                            <div class="row mb-2">
                              <div
                                class="col-xl-7 col-md-6 ticket-mtitle font-weight-bold"
                              >
                                Total
                              </div>
                              <div
                                class="col-md-6 col-xl-5 ticket-mtitle font-weight-bold pr-0 d-flex justify-content-end"
                              >
                                {{ curr_code }}
                                {{ currFormat(totalPayableAmount) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="col-md-3 col-lg-2"></div>-->
                <!-- <div class="col-md-7 col-lg-7 pl-0 d-none"></div> -->
                <!-- <div class="col-md-2 col-lg-3 align-self-center text-center"></div>-->

                <div
                  class="col-4 text-center p-3 p-xl-5 mt-border mt-qr-section"
                >
                  <div
                    class="h-100 d-flex align-items-center justify-content-center"
                  >
                    <div class="w-100">
                      <p class="info" v-if="true">
                        Use this QR Code to Enter the Cinema
                      </p>
                      <div class="pb-2">
                        <img
                          :src="bookingDetails.qrcode"
                          :alt="'name'"
                          height="150px"
                          width="150px"
                          class="img-fluid qr-code"
                        />
                      </div>

                      <!-- PROGRESS BAR -->
                      <div class="pt-3 pb-4">
                        <div
                          class="pb-1 text-center"
                          v-if="
                            bookingDetails.booking_type_id != 3 &&
                              bookingDetails.booking_type_id
                          "
                        >
                          <p
                            class="mb-0 font-weight-bold"
                            :style="
                              bookingDetails.booking_type_id == '2'
                                ? 'color:red'
                                : ''
                            "
                          >
                            {{
                              bookingDetails.booking_type_id == 2
                                ? "Not Confirmed"
                                : "Confirmed"
                            }}
                          </p>
                        </div>
                        <div
                          v-if="
                            bookingDetails.booking_type_id != 3 &&
                              bookingDetails.booking_type_id
                          "
                        >
                          <!-- Unconfirmed -->
                          <b-progress
                            v-if="bookingDetails.booking_type_id == 2"
                            :max="parseInt(bookingDetails.screen_total_seats)"
                            class="proBar ticket-proBar red mb-0"
                          >
                            <b-progress-bar
                              :value="bookingDetails.booked_seats"
                            ></b-progress-bar>
                            <p
                              :class="
                                bookingDetails.booking_type_id == 1
                                  ? 'd-none'
                                  : ''
                              "
                              class="mb-0 reqText mx-auto pr-2"
                            >
                              {{
                                bookingDetails.booking_type_id == 2
                                  ? `Need ${bookingDetails.min_seats -
                                      bookingDetails.booked_seats} Seats to confirm`
                                  : `${bookingDetails.screen_total_seats -
                                      bookingDetails.booked_seats} seats left`
                              }}
                            </p>
                          </b-progress>
                          <!-- Confirmed -->
                          <b-progress
                            v-if="bookingDetails.booking_type_id == 1"
                            :max="parseInt(100)"
                            class="proBar ticket-proBar mb-0"
                          >
                            <b-progress-bar :value="parseInt(100)">
                              <p class="mb-0 succ-text">
                                {{
                                  bookingDetails.booking_type_id == 2
                                    ? `Need ${bookingDetails.min_seats -
                                        bookingDetails.booked_seats} seats to confirm`
                                    : `${bookingDetails.screen_total_seats -
                                        bookingDetails.booked_seats} seats left`
                                }}
                              </p>
                            </b-progress-bar>
                          </b-progress>
                        </div>
                        <div v-else-if="bookingDetails.booking_type_id == 3">
                          <b-progress
                            :max="parseInt(bookingDetails.screen_total_seats)"
                            class="proBar ticket-proBar bg-warning mb-0"
                          >
                            <b-progress-bar></b-progress-bar>
                            <p class="mb-0 reqText mx-auto pr-2">
                              Private Screening
                            </p>
                          </b-progress>
                        </div>
                        <div v-else>
                          <b-progress
                            :max="parseInt(100)"
                            class="proBar ticket-proBar bg-success mb-0"
                          >
                            <b-progress-bar></b-progress-bar>
                            <p class="mb-0 reqText mx-auto pr-2">
                              Regular Screening
                            </p>
                          </b-progress>
                        </div>
                        <input
                          type="text"
                          id="copyText"
                          :value="
                            bookingDetails.ShowType != 'Private'
                              ? 'Join me on GoGoCinema to watch ' +
                                bookingDetails.movie_title +
                                ' at ' +
                                bookingDetails.cine_name +
                                ' on ' +
                                bookingDetails.show_date +
                                ' at ' +
                                timeFormat(bookingDetails.show_time) +
                                '. Click the below link to join: \n' +
                                bookingDetails.shortLinkPwa
                              : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                                bookingDetails.movie_title +
                                ' at ' +
                                bookingDetails.cine_name +
                                ' on ' +
                                bookingDetails.show_date +
                                ' at ' +
                                timeFormat(bookingDetails.show_time) +
                                '.'
                          "
                          style="opacity:0;height:1px"
                        />
                        <div
                          v-if="
                            bookingDetails.ShowStatusMsg == 'UNCONFIRMED' ||
                              bookingDetails.ShowStatusMsg == 'CONFIRMED'
                          "
                        >
                          <div
                            id="tooltip-button"
                            class="btn-share"
                            @click="copyTextShare()"
                          >
                            <p style="cursor:pointer">Share</p>
                          </div>
                        </div>
                        <b-tooltip
                          :show="bookingDetails.show"
                          :disabled="true"
                          target="tooltip-button"
                          placement="bottom"
                          variant="outline-success"
                          custom-class="tool-tip-cop"
                        >
                          <strong>Copied</strong>
                        </b-tooltip>
                      </div>
                      <!-- <div class="text-danger font-weight-bold pt-3">CANCELLED</div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-11 mx-auto mt-3">
          <ul class="list-inline">
            <li class="list-inline-item mr-md-3">
              <p class="mb-1 text-muted">Booking Date &amp; Time:</p>
              <span>{{ bookingDetails.transaction_date_time | datetime }}</span>
              <!-- <span class>{{bookingDetails.ShowTime}} |</span>
              <span class>{{" " + bookingDetails.ShowDate | moment}}</span>-->
            </li>
            <li class="list-inline-item mr-md-3">
              <p class="mb-1 text-muted">Payment Method</p>
              <span>{{ bookingDetails.pm_payment_mode || "-" }}</span>
            </li>
            <li class="list-inline-item mr-md-3">
              <p class="mb-1 text-muted">Booking ID</p>
              <span>{{ bookingDetails.sb_booking_code }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- <div class="text-center my-4 my-md-5">
        <img src="@/assets/img/svg/SeparatorOR.svg" class="img-fluid">
      </div>-->
    </div>

    <!-- NEW MOBILE M-TICKET -->
    <div class="col-12 col-md-6 mx-auto px-0 d-block d-lg-none">
      <div class="new-mTicket bg-light">
        <div class="ticket-info">
          <div class="px-3 py-3">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <div>
                <img src="@/assets/img/svg/new-gogo-logo.svg" alt />
              </div>

              <div class="text-right">
                <!-- <img src="@/assets/img/svg/close-icon-new.svg" class="ml-auto" alt /> -->
                <p class="pt-2">
                  Ticket No :{{ bookingDetails.sb_booking_code }}
                </p>
              </div>
            </div>

            <div class="col-12 px-0">
              <!-- MOVIE DETAILS -->
              <div class="border-bottom pb-2">
                <p class="movie-title">{{ bookingDetails.movie_title }}</p>
                <ul class="list-inline extra-movie-info py-1">
                  <li class="list-inline-item">{{ "300 min" }}</li>
                  <li class="list-inline-item">
                    {{ bookingDetails.lang_name }}
                  </li>
                  <li class="list-inline-item">{{ bookingDetails.mf_name }}</li>
                </ul>
                <p class="dark-txt">{{ bookingDetails.cine_name }}</p>
              </div>
              <!-- TICKET INFO -->
              <div class="row pt-2">
                <div class="col-8">
                  <div class="mb-3">
                    <p class="light-txt">Date :</p>
                    <p class="dark-txt">
                      {{ bookingDetails.show_date | moment }}
                    </p>
                  </div>

                  <div class="mb-3">
                    <p class="light-txt">
                      Seats : - ({{ bookingDetails.seats.join(",") }})
                    </p>
                    <ul class="list-inline m-ticket-seats">
                      <li
                        class="list-inline-item"
                        v-for="(item, index) in bookingDetails.seats"
                        :key="index"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-4">
                  <div class="mb-3">
                    <p class="light-txt">Time :</p>
                    <p class="dark-txt">
                      {{ timeFormat(bookingDetails.show_time) }}
                    </p>
                  </div>

                  <div class="mb-3">
                    <p class="light-txt">Screen No.</p>
                    <p class="dark-txt">{{ bookingDetails.screen_name }}</p>
                  </div>
                </div>
              </div>

              <!-- TICKET PRICE -->
              <div class="row pb-2">
                <div class="col-8">
                  <p class="light-txt mb-1">Ticket Price</p>
                  <p class="light-txt mb-1" v-if="bookingDetails.total_tax">
                    TAX
                  </p>
                  <p
                    class="light-txt mb-1"
                    v-if="bookingDetails.internet_handling_fee"
                  >
                    Service Charge
                  </p>
                  <p class="light-txt mb-1" v-if="bookingDetails.offer_price">
                    Discount
                  </p>
                </div>

                <div class="col-4">
                  <p class="normal-txt">
                    {{ curr_code }}
                    {{ currFormat(bookingDetails.sb_total_net_amount) }}
                  </p>
                  <p class="normal-txt" v-if="bookingDetails.total_tax">
                    {{ curr_code }}
                    {{
                      currFormat(
                        bookingDetails.sb_total_amount -
                          bookingDetails.sb_total_net_amount
                      )
                    }}
                  </p>
                  <p
                    class="normal-txt"
                    v-if="bookingDetails.internet_handling_fee"
                  >
                    {{ curr_code }}
                    {{ currFormat(bookingDetails.internet_handling_fee) }}
                  </p>
                  <p class="normal-txt" v-if="bookingDetails.offer_price">
                    {{ curr_code }} {{ currFormat(bookingDetails.offer_price) }}
                  </p>
                </div>
              </div>

              <!-- TICKET PRICE TOTAL -->
              <div class="row border-top pt-2">
                <div class="col-8">
                  <p class="light-txt">Total</p>
                </div>

                <div class="col-4">
                  <p class="dark-txt">
                    {{ curr_code }} {{ currFormat(totalPayableAmount) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="qr-section qr-section pt-3 pb-5">
          <!-- PROGRESS BAR -->
          <div
            class="pt-3 pb-0 px-3 px-md-4"
            :style="
              bookingDetails.ShowType == 'Private' ? 'margin: 2px 54px;' : ''
            "
          >
            <div
              class="pb-1 text-center"
              v-if="bookingDetails.ShowType != 'Private'"
            >
              <p
                v-if="bookingDetails.ConfirmedStatus == false"
                class="mb-0 font-weight-bold"
                :style="bookingDetails.ShowStatus == '2' ? 'color:red' : ''"
              >
                {{ bookingDetails.ShowStatusMsg }}
              </p>
              <p
                v-if="bookingDetails.ConfirmedStatus"
                class="mb-0 font-weight-bold"
                :style="bookingDetails.ShowStatus == '3' ? 'color:red' : ''"
              >
                {{ bookingDetails.ShowStatusMsg }}
              </p>
            </div>
            <div v-if="bookingDetails.ShowType != 'Private'">
              <!-- UNCONFIRMED -->
              <div
                class="new-progress-bar unconfirmed"
                v-if="
                  bookingDetails.ConfirmedStatus == false &&
                    bookingDetails.ShowStatus == '0'
                "
              >
                <b-progress
                  style="width:10%"
                  :max="parseInt(bookingDetails.TotalSeat)"
                >
                  <b-progress-bar></b-progress-bar>
                </b-progress>
                <p class="proBar-text" v-html="bookingDetails.ExpiryMsg"></p>
              </div>

              <!-- CONFIRMED -->
              <div
                class="new-progress-bar confirmed"
                v-if="
                  bookingDetails.ConfirmedStatus &&
                    bookingDetails.ShowStatus == '1'
                "
              >
                <b-progress
                  style="width:100%"
                  :max="parseInt(bookingDetails.TotalSeat)"
                >
                  <b-progress-bar></b-progress-bar>
                </b-progress>
                <p class="proBar-text" v-html="bookingDetails.ExpiryMsg"></p>
              </div>
            </div>
            <div class="new-progress-bar bg-warning" v-else>
              <b-progress
                style="width:0%"
                :max="parseInt(bookingDetails.TotalSeat)"
              >
                <b-progress-bar></b-progress-bar>
              </b-progress>
              <p class="proBar-text">Private Screening</p>
            </div>
          </div>
          <div class="align-self-center text-center">
            <p class="qr-note" v-if="bookingDetails.ShowStatus == '1'">
              Use this QR Code to Enter the Cinema
            </p>
            <div class="py-3">
              <img
                :src="bookingDetails.qrcode"
                alt="'name'"
                height="150px"
                width="150px"
                class="img-fluid qr-code"
              />
              <!-- <div class="tag">unconfirmed</div> -->
            </div>
            <div
              v-if="
                bookingDetails.ShowStatusMsg == 'UNCONFIRMED' ||
                  bookingDetails.ShowStatusMsg == 'CONFIRMED'
              "
            >
              <navigator-share
                v-bind:on-error="onError"
                v-bind:on-success="onSuccess"
                :text="
                  bookingDetails.ShowType != 'Private'
                    ? 'Join me on GoGoCinema to watch ' +
                      bookingDetails.Title +
                      ' at ' +
                      bookingDetails.CinemaName +
                      ' on ' +
                      bookingDetails.ShowDate +
                      ' at ' +
                      bookingDetails.ShowTime +
                      '. Click the below link to join: \n' +
                      bookingDetails.shortLinkPwa
                    : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                      bookingDetails.Title +
                      ' at ' +
                      bookingDetails.CinemaName +
                      ' on ' +
                      bookingDetails.ShowDate +
                      ' at ' +
                      bookingDetails.ShowTime +
                      '.'
                "
                class="btn-share"
              ></navigator-share>
              <!-- <router-link class="txt14-light-blue" to>
                  <img src="@/assets/img/svg/share-btn-img.svg" alt />
              </router-link>-->
            </div>
            <!-- <div class="text-danger font-weight-bold pt-3">CANCELLED</div> -->
          </div>
        </div>
      </div>
      <br />
    </div>
    <div class="col-12 col-md-10 col-lg-6 mx-auto my-5 d-none d-lg-block">
      <div class="row">
        <!-- <div class="col-6 col-lg-5 col-xl-4 mx-auto text-center">
          <button class="btn btn-danger w-100 gogo-btn" v-b-modal.invite>INVITE FRIEND</button>
        </div>-->
        <!-- <div class="col-3 mx-auto text-center">
               <button class="btn btn-danger w-100 gogo-cus-btn">SHARE</button>
        </div>-->
        <div class="col-6 col-lg-5 col-xl-4 mx-auto text-center">
          <!-- <button @click="print" class="btn btn-danger w-100 gogo-btn">
            Print Ticket
          </button> -->
          <router-link
            class="mt-3 btn btn-danger text-light"
            :to="{
              name: 'Home'
            }"
            >Home</router-link
          >
        </div>
      </div>
    </div>
    <!-- <div class="col-12 col-md-10 col-lg-6 col-xl-5 mTicketTxt mb-5 px-0 px-md-3 mx-auto">
        <p @click="printTicket()" class="mb-0 mb-3">Send M-Ticket to a friend</p>
        <form class="d-md-flex w-100">
          <input type="text" class="form-control mr-3 py-4" placeholder="Friend's Mobile Number/ E-mail id">
          <button type="submit" class="btn btn-send mt-3 mt-md-0">Send</button>
        </form>
    </div>-->
    <div class="invite-pop">
      <!-- <b-button v-b-modal.otp>Verify otp</b-button> -->
      <!-- Modal Component -->
      <b-modal
        ref="invitemodal"
        title="Invite Friend"
        class="welcome-b header"
        id="invite"
        hide-footer
      >
        <div class="p-4">
          <div class="invite-section">
            <p class="invite-txt mb-3">Send ticket to a friend</p>
            <form data-vv-scope="inviteFriend" class="d-md-flex w-100">
              <input
                v-model="friendemail"
                v-validate="'required|email'"
                type="text"
                name="email"
                class="form-control py-4 w-100"
                placeholder="Enter Your Friend's Email Address"
              />
            </form>
            <div
              v-show="errors.has('inviteFriend.email')"
              class="py-1 text-danger font-weight-bold small"
            >
              {{ errors.first("inviteFriend.email") }}
            </div>
          </div>
          <div class="text-danger mt-3 small font-weight-bold">
            {{ errorMessage }}
          </div>
          <div class="mt-3">
            <input
              @click.stop="validateBeforeSubmit('inviteFriend')"
              type="submit"
              class="gogo-btn btn btn-danger"
              value="Send"
            />
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
//import { dragscroll } from 'vue-dragscroll'
import { makeRequest } from "@/helper/internet.js";
import { TokenService } from "@/services/storage.service";
import NavigatorShare from "vue-navigator-share";
import moment from "moment";
import MainServices from "@/services/mainService.js";
import AuthServices from "@/services/AuthServices.js";
import PromotionServices from "@/services/PromotionServices.js";

export default {
  name: "confirmScreen",
  directives: {
    //'dragscroll':dragscroll
  },

  components: {
    Slick,
    DatePick,
    NavigatorShare
  },

  data() {
    return {
      legacySystemHTML: "",
      bookingDetails: {},
      bookingId: "",
      paymentId: "",
      friendemail: "",
      errorMessage: "",
      reserveID: "",
      counter: 0,
      show_booking_id: null,
      category_id: null
    };
  },
  filters: {
    moment(date) {
      return moment(date).format("DD-MMM-YYYY");
    },
    datetime(date) {
      return moment(date).format("DD-MMM-YYYY HH:mm");
    }
  },
  computed: {
    totalPayableAmount() {
      let total =
        this.bookingDetails.sb_total_amount - this.bookingDetails.offer_price  - this.bookingDetails.TaxOffer;
      return total;
    },
    curr_code() {
      return this.$store.getters.getCurrCode;
    },
    userInfo() {
      if (localStorage.getItem("user")) {
        let user = JSON.parse(localStorage.getItem("user"));
        this.userLoggedIn = true;
        return user;
      } else {
        return false;
      }
    }
  },
  beforeMount() {
    // if (this.$route.params.paymentId == 3) {
    //   this.reserveID = this.$route.params.bookingId;
    //   this.confirmBookingStatus();
    // } else {
    this.show_booking_id = this.$route.params.show_booking_id;
    this.category_id = this.$route.params.category_id || 1;
    this.fetchBookingDetails();
  },
  methods: {
    copyTextShare() {
      var copyText = document.getElementById("copyText");
      copyText.select();
      document.execCommand("copy");
      var self = this;
      this.bookingDetails["Title"] = this.bookingDetails["Title"] + "  ";
      this.bookingDetails.show = true;
      setTimeout(function() {
        self.bookingDetails.show = false;
        self.bookingDetails["Title"] = self.bookingDetails["Title"] + " ";
      }, 2000);
    },
    onError(err) {
      alert(err);
      console.log(err);
    },
    onSuccess(err) {
      console.log(err);
    },
    confirmBookingStatus: function() {
      let payload = {
        PaymentID: 3,
        ReserveID: this.reserveID
      };
      if (this.counter > 30) {
        window.location =
          window.location.origin +
          "/failedPayment/" +
          this.$route.query.MovieID +
          "/" +
          this.$route.query.CategoryID +
          "/" +
          this.$route.query.CinemaScheduleID;
        return;
      }

      makeRequest("/getBookingStatus/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          this.counter++;
          if (res.data.Status == false) {
            setTimeout(this.confirmBookingStatus, 2000);
          } else {
            this.paymentId = this.$route.params.paymentId;
            this.bookingId = res.data.BookingID;
            this.fetchBookingDetails();
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    print() {
      this.legacySystemHTML = ` <div id="printMe1" marginwidth="0" marginheight="0" style="display:none;font-family:Arial,sans-serif;background:#fff">
    <table style="  margin: 0 auto;min-width: 650px;max-width: 650px;border: 1px solid #e5e5e5;border-spacing: 0;">
        <tbody>
            <tr>
                <td
                    style="height: 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);border:0;">
                </td>
            </tr>
            <tr>
                <td
                    style="padding:15px 25px 15px 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;border:0;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);color:#828282">
                    <img src="https://img.gogocinema.com/assets/images/organization/5d59922b95715.png">
                </td>
            </tr>
            <tr>
                <td
                    style="padding:20px 25px 20px 25px;font-size:16px;font-weight:bold;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;color:#2B2D42">
                    <span
                        style="font-size: 30px; text-align: center; letter-spacing: -0.5px; color: #2B2D42;">Congratulations!</span>
                </td>
            </tr>
            <tr>
                <td
                    style="padding:10px 25px 10px 25px;font-size: 14px;text-align: center;color: #2B2D42;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;">
                    Your tickets for <span style="color: #45BB4D">${
                      this.bookingDetails.Title
                    } </span>are confirmed.
                </td>
            </tr>
            <tr>
                <td
                    style="padding:5px 25px 25px 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;color: #2B2D42">
                    Your Booking ID <span style="font-size: 18px;text-align: center;color: #2B2D42;"> ${parseInt(
                      this.bookingId
                    )}</span>
                </td>
            </tr>
            <tr>
                <td>
                    <table
                        style="font-family: Arial,sans-serif; width: 360px;background-color:#E70D00;display: block;margin: 0 auto;">
                        <tr>
                            <td style="width: 360px;padding-top:15px;padding-bottom: 15px;">
                                <table
                                    style="width: 330px; margin: 0 auto;background-color: #fff;border-radius: 15px;border-spacing: 0;">
                                    <tr>
                                        <td colspan="2" style="vertical-align: top; padding: 0; text-align: center;">
                                            <img src="https://i.imgur.com/u8YQEpM.png" width="70">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style="width: 60%;padding-left: 15px;padding-bottom: 15px;">
                                            <img src="https://i.imgur.com/rC3q0us.png" height="33" width="65" alt="">
                                        </td>
                                        <td
                                            style="width: 40%;vertical-align: bottom; padding-right: 15px;padding-bottom: 15px;">
                                            <p style="font-size: 10px;margin: 0;">Ticket No : ${parseInt(
                                              this.bookingId
                                            )}</p>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td colspan="2"
                                            style="padding-left: 15px;padding-right:15px;padding-bottom: 10px;  ">
                                            <p
                                                style="font-size: 20px;font-weight: bold; color:#2B2D42;margin: 0;padding-bottom: 5px;">
                                               ${this.bookingDetails.Title}
                                            </p>
                                            <p
                                                style="font-size: 12px;font-weight: bold; color:#252525;margin: 0; padding-bottom: 8px;">
                                                <span>${
                                                  this.bookingDetails.Rated
                                                }</span> |
                                                <span>${
                                                  this.bookingDetails.Language
                                                } </span> |
                                                <span>${
                                                  this.bookingDetails.Format
                                                }</span>
                                            </p>
                                            <p style="font-size: 12px;font-weight: bold; color:#252525;margin: 0;">
                                                ${
                                                  this.bookingDetails.CinemaName
                                                }
                                            </p>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td colspan="2"
                                            style="padding-left: 15px;padding-right: 15px;padding-bottom: 10px;">
                                            <p style="width: 100%;border-bottom: 1px solid #8D99AF;margin:0;"></p>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td
                                            style="width: 60%;padding-left: 15px;padding-right: 15px; padding-bottom: 15px;">
                                            <p style="font-size: 12px;color: #8D99AE;margin:0;padding-bottom: 4px;">Date
                                            </p>
                                            <p style="font-size: 14px;font-weight: bold; color: #252525;margin: 0;">
                                                 ${this.bookingDetails.ShowDate}
                                            </p>
                                        </td>
                                        <td
                                            style="width: 40%;vertical-align: top;padding-right: 15px;padding-bottom: 15px;">
                                            <p style="font-size: 12px;color: #8D99AE;margin: 0;padding-bottom: 5px;">
                                                Time</p>
                                            <p style="font-size: 14px;font-weight: bold; color: #252525;margin: 0;">
                                                  ${
                                                    this.bookingDetails.ShowTime
                                                  } </p>
                                        </td>
                                    </tr>


                                    <tr>
                                        <td
                                            style="width: 60%;vertical-align: top;padding-left: 15px;padding-right: 15px;padding-bottom: 15px;">
                                            <p style="font-size: 12px;color: #8D99AE;margin: 0;padding-bottom: 5px;">
                                                Seats : -
                                                (${
                                                  this.bookingDetails.SeatsCount
                                                })
                                            </p>
                                            <p style="font-size: 14px;font-weight: bold; color: #252525;margin:0;word-break:break-all;">
                                                ${this.bookingDetails.Seats}
                                            </p>
                                        </td>
                                        <td
                                            style="width: 40%;vertical-align: top;padding-right: 15px;padding-bottom: 15px;">
                                            <p style="font-size: 12px;color: #8D99AE;margin: 0;padding-bottom: 5px;">
                                                Screen No.</p>
                                            <p style="font-size:14px;font-weight: bold;color:#252525;margin: 0;"> ${
                                              this.bookingDetails.ScreenNo
                                            }
                                            </p>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style="width: 60%;padding-left: 15px;padding-right: 15px;">
                                            <p style="font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;">Ticket
                                                Price</p>
                                            <p style="font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;">GST
                                            </p>
                                            <p style="font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;">
                                                Service Charge</p>
                                            <p style="font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;">
                                                Discount</p>
                                        </td>
                               <td style="width: 40%;padding-right: 15px;">
                                <p style="font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;">${
                                  this.bookingDetails.Currency
                                } ${this.bookingDetails.TotalPrice} </p>
                                <p style="font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;">${
                                  this.bookingDetails.Currency
                                } ${this.bookingDetails.GST}</p>
                                <p style="font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;">${
                                  this.bookingDetails.Currency
                                } ${this.bookingDetails.TicketHandling}</p>
                                <p style="font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;">${
                                  this.bookingDetails.Currency
                                } ${this.bookingDetails.Discount}</p>
                            </td>
                                    </tr>

                                    <tr>
                                        <td colspan="2" style="padding-left: 15px;padding-right: 15px;">
                                            <p style="width: 100%;border-bottom: 1px solid #8D99AF;margin:0;"></p>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style="width: 60%;padding: 5px 10px 10px 15px;">
                                            <p style="font-size: 12px;color: #8D99AE;margin: 0;">Total</p>
                                        </td>
                                        <td style="width: 40%;padding: 5px 10px 10px 0px;">
                                            <p style="font-size: 14px;color: #252525;margin: 0;">${
                                              this.bookingDetails.Currency
                                            } ${this.bookingDetails.Total}</p>
                                        </td>
                                    </tr>

                                    <!-- <tr>
                                <td colspan="2" style="border-bottom: 1px dashed #252525;"></td>
                            </tr> -->

                                    <tr>
                                        <td colspan="2" style="padding:0;">
                                            <img src="https://i.imgur.com/JN4vNty.png" style="width: 100%" alt="">
                                        </td>
                                    </tr>

                                    <tr>
                                      <td colspan="2"
                                            style="text-align: center;padding-left: 15px;padding-right: 15px;padding-bottom: 15px;">
                                            ${
                                              this.bookingDetails.ShowType ==
                                              "Private"
                                                ? ""
                                                : `<p style="font-size: 14px;color:#2B2D42;font-weight: bold;" >${this.bookingDetails.ShowStatusMsg}</p>`
                                            }

                                            <p
                                                style="height: 20px;background:  #e4e4e4;border-radius: 5px; ${
                                                  this.bookingDetails
                                                    .ShowType == "Private"
                                                    ? "margin-left:23%;width: 51%"
                                                    : "width:100%"
                                                } ">
                                                <span
                                                    style="font-size: 12px; font-weight: bold; display: block;text-align: center; color:#000; height: 20px; width: 100%;background: ${
                                                      this.bookingDetails
                                                        .ShowType == "Private"
                                                        ? "#ffc107"
                                                        : this.bookingDetails
                                                            .ShowStatusMsg ==
                                                          "CONFIRMED"
                                                        ? "#45bb4d"
                                                        : this.bookingDetails
                                                            .ShowStatusMsg ==
                                                          "UNCONFIRMED"
                                                        ? "#E70D00"
                                                        : "#000"
                                                    };border-radius: 5px;">

                                                    <span style="display:block;padding-top:3px;"> ${
                                                      this.bookingDetails
                                                        .ShowType != "Private"
                                                        ? this.bookingDetails
                                                            .ExpiryMsg
                                                        : "Private Screening"
                                                    }</span>
                                                </span>
                                            </p>

                                            <p style="font-size: 12px;color:#252525;">Use this QR Code to Enter the
                                                Cinema</p>

                                            <p>
                                                <img src="${
                                                  this.bookingDetails.qrcode
                                                }" height="100px" width="100px">
                                            </p>
                                             </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="vertical-align: bottom; padding: 0;">
                                            <img src="https://i.imgur.com/qd4gKqH.png" width="70"
                                                style="margin-bottom:-1px;display: block; margin: 0 auto;">
                                        </td>
                                    </tr>
                                 </table>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>

            <tr>
                <td align="center"
                    style="padding:15px 0 0px 0; font-weight: bold; font-size: 18px;line-height: 28px;letter-spacing: -0.5px;color: #252525;font-family:Arial,sans-serif;vertical-align:top;background-color:#ffffff;">
                    <a href="http://test.gogocinema.com/terms-condition-ticket"
                        style="font-size: 12px;font-weight: 300;text-decoration: none;" target="_blank">Click Here For
                        Terms and Conditions</a>
                </td>
            </tr>
            <tr>
                <td
                    style="height: 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);border:0;">
                </td>
            </tr>
        </tbody>

    </table>
</div>`;
      // Pass the element id here

      this.$nextTick(() => {
        this.$htmlToPaper("printMe1");
      });
    },
    fetchBookingDetails: function() {
      this.showLoading();
      let payload = {
        sb_id: this.show_booking_id,
      };
      MainServices.GetBookingDetailsVista(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            console.log("data booking", data);
            this.bookingDetails = data.Records[0];
            this.bookingDetails["show"] = false;
          }
        })
        .catch(err => {
          console.log("Error:", err);
        })
        .finally(() => {
          this.hideLoading();
        });
      // makeRequest("/Booking/GetBookingDetails", "POST", token, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     this.hideLoading();

      //     this.bookingDetails = res.data;
      //     this.bookingDetails.Seats = this.bookingDetails.Seats.split(",").join(
      //       ", "
      //     );
      //     this.bookingDetails.SeatsLeft =
      //       parseInt(this.bookingDetails.TotalSeat) -
      //       parseInt(this.bookingDetails.SeatsBooked);
      //     this.bookingDetails["show"] = false;
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },
    validateBeforeSubmit(scope) {
      if (scope == "inviteFriend") {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.showLoading();
            let token = TokenService.getToken();
            let payload = {
              FriendEmail: this.friendemail,
              BookingID: this.bookingId
            };
            makeRequest("/Booking/ResendTickets", "POST", token, payload)
              .then(response => {
                const { error, res } = response;
                this.hideLoading();
                if (!error && res.data.Status) {
                  this.errorMessage =
                    "Ticekt has been sent to your friend's email address";
                } else {
                  this.errorMessage = res.data.Message;
                }
                setTimeout(() => {
                  this.$refs.invitemodal.hide();
                }, 3000);
              })
              .catch(error => {
                this.errorMessage = "Something went wrong!";
                console.log("Error", error);
              });
            return;
          }
        });
      }
    }
  }
};
</script>

<style scoped>
body {
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background: url("../../../assets/img/svg/bg.svg");
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ExternalConfirmScreen/confirmScreenVista.vue